import Callout from "components/callout/callout"
import { useTranslation } from "react-i18next"
import useNotifications from "@/hooks/useNotifications"
import useLayout from "hooks/useLayout"
import Form from "components/forms/form"
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import Button from "components/inputs/button"
import ButtonGroup from "components/buttons/buttonGroup"
import Section from "components/layout/section"
import { FormStatus } from "@/types"

interface DeleteNotificationFormProps {
    notificationId: string
}

const DeleteNotificationForm: React.FC<DeleteNotificationFormProps> = ({ notificationId }) => {

    const { t } = useTranslation()

    const {
        notifications,
        notificationsStatus,
        deleteNotification,
    } = useNotifications()

    const notification = notifications.find((entry) => entry.id === notificationId)
    const title = notification?.title || notification?.id || ``

    const { closeDialog, addToast } = useLayout()

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        closeDialog()
        void deleteNotification(notificationId).catch(() => {
            addToast({ text: t('toastNotificationDeleteError'), colorScheme: 'red' })
        })
    }

    if (!notificationId) return <Callout type={'error'}>{t('Missing notificationId')}</Callout>
    if (notificationsStatus === FormStatus.LOADING) return <Callout type={`neutral`} loadingIcon={true}>{t('loadingNotification')}</Callout>
    if (notificationsStatus === FormStatus.ERROR) return <Callout type={'error'}>{t('errorLoadingData')}</Callout>
    if (!notification) return <Callout type={'error'}>{t('errorNotificationNotFound')}</Callout>

    return (
        <Form
            onSubmit={handleSubmit}
            className={`group`}
        >
            <Section>
                <p>{t('deleteNotificationConfirmation', { title })}</p>
                <ButtonGroup>
                    <Button wideOnMobile type="button" design="optional" onClick={closeDialog}><CloseIcon /><span>{t('buttonCancel')}</span></Button>
                    <Button wideOnMobile type="submit" design="danger"><DeleteIcon /><span>{t('delete')}</span></Button>
                </ButtonGroup>
            </Section>
        </Form>
    )
}

export default DeleteNotificationForm
